module.exports = __webpack_public_path__ + "static/media/glass_opendoor_left.c1110b0a.png";